@if (!isAccessFlagLoading() && !isUrlVerified()) {
  <app-url-verification
    [hasAccess]="isAccessEnabled()"
    [noAccessMessage]="featureFlagErrorText | translate"
    [tenantApiBaseUrl]="tenantService.BASE_URL"
    (successfulVerificationEvent)="onSuccessfulVerification()"
    (mustSignOutEvent)="signOut()"
  >
  </app-url-verification>
} @else if (isAuthReady() && user()) {
  <div class="flex flex-column h-screen w-full">
    <app-banner
      class="w-full flex-shrink-0"
      [title]="'intelligenceSettings' | translate"
      [user]="user()"
      [isWebApps]="isWebApps"
      [hasWebCapture]="hasWebCapture()"
      [hasTranscriptProcessing]="hasTranscriptProcessing()"
    >
    </app-banner>

    <div class="flex flex-1 w-full overflow-hidden">
      <app-sidebar
        class="h-full flex-shrink-0"
        [menuSections]="menuSections()"
      ></app-sidebar>

      <div class="flex-1 p-3 overflow-auto component-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
